
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import moment from 'moment';
    import {ls} from "@/CultureService";

    @Component
    export default class TimePicker extends Vue{
        @Prop({default: ls.Components_TimePicker_Placeholder_ChooseTime})
        placeholder!: string;
        @Prop({default: ""})
        id!: string;
        @Prop()
        value!: Date;
        
        timeString = "";

        handleInput (input: string) {
            const time = input.split(":");
            const date = moment(this.value || new Date()).set({hours: +time[0], minutes: +time[1]}).toDate();
            this.$emit('input', date);

        }
        
        created(){
            this.$watch(() => this.value, value => {
                this.timeString = moment(value).format("HH:mm:ss");
            });
        }
    }
